import { Component, Input } from '@angular/core';
import { CAMINHOS_UF, VIEWBOX_MAPA_UF } from './mapa-uf-ibpt.caminhos';

/**
 * Mapa do Brasil da Tabela IBPT por UF, em três usos:
 * - importação: concluída (nenhuma linha rejeitada), parcial (linhas válidas e rejeitadas), falhou (nenhuma linha
 *   válida) ou não enviada (UF ausente de situacaoPorUf);
 * - andamento da carga pela API: consultada, em consulta ou a consultar (UF ausente de situacaoPorUf);
 * - situação da tabela: carregada ou sem tabela (UF ausente de situacaoPorUf).
 */
@Component({
  selector: 'app-mapa-uf-ibpt',
  templateUrl: './mapa-uf-ibpt.component.html',
  styleUrl: './mapa-uf-ibpt.component.css',
})
export class MapaUfIbptComponent {
  @Input() tipo: 'importacao' | 'andamento' | 'situacao' = 'importacao';
  @Input() situacaoPorUf: Record<
    string,
    'concluida' | 'parcial' | 'falhou' | 'consultada' | 'emConsulta' | 'carregada'
  > = {};

  public readonly listaCaminhoUf = CAMINHOS_UF;
  public readonly viewBox = VIEWBOX_MAPA_UF;

  public descricaoSituacao(sigla: string): string {
    switch (this.situacaoPorUf[sigla]) {
      case 'concluida':
        return 'Concluída';
      case 'parcial':
        return 'Parcial';
      case 'falhou':
        return 'Falhou';
      case 'consultada':
        return 'Consultada';
      case 'emConsulta':
        return 'Em consulta';
      case 'carregada':
        return 'Carregada';
      default:
        if (this.tipo === 'andamento') {
          return 'A consultar';
        }

        return this.tipo === 'situacao' ? 'Sem tabela' : 'Não enviada';
    }
  }
}
